import { EducationLevelFilter } from '@cpd-app/generated';

export const edLevelToEdLevelFilterMapper = (
  level: number
): EducationLevelFilter => {
  switch (level) {
    case 3:
      return EducationLevelFilter.Certificate;
    case 5:
      return EducationLevelFilter.Associates;
    case 6:
      return EducationLevelFilter.Bachelors;
    case 8:
      return EducationLevelFilter.Masters;
    default:
      return EducationLevelFilter.Any;
  }
};
